import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const CardWrapper = styled(Box)(({ theme, accentColor }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  boxShadow: theme.shadows[1],
  borderLeft: `4px solid ${accentColor || theme.palette.primary.main}`,
  padding: '16px 16px 16px 20px',
  overflow: 'hidden',
  transition: 'box-shadow 0.2s ease, transform 0.2s ease',
  cursor: 'default',
  display: 'flex',
  alignItems: 'flex-start',
  gap: 12,
  minWidth: 0,

  '&:hover': {
    boxShadow: theme.shadows[2],
    transform: 'translateY(-2px)',
  },
}));

export const IconCircle = styled(Box)(({ accentColor, theme }) => ({
  flexShrink: 0,
  width: 40,
  height: 40,
  borderRadius: '50%',
  backgroundColor: (accentColor || theme.palette.primary.main) + '1A', // 10% opacity
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: accentColor || theme.palette.primary.main,
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
}));

export const ContentBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  flex: 1,
});

export const TitleText = styled('span')(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  fontWeight: theme.typography.caption.fontWeight,
  color: theme.palette.text.secondary,
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const ValueText = styled('span')(({ theme }) => ({
  fontSize: theme.typography.metric.fontSize,
  fontWeight: theme.typography.metric.fontWeight,
  color: theme.palette.text.primary,
  lineHeight: 1.2,
  marginTop: 2,
}));

export const UnitText = styled('span')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  color: theme.palette.text.secondary,
  marginLeft: 4,
}));

export const TrendBadge = styled(Box)(({ trend, theme }) => {
  let color = theme.palette.text.disabled;
  let bg = theme.palette.surface.elevated;
  if (trend > 0) {
    color = theme.palette.success.main;
    bg = theme.palette.success.main + '14'; // 8% opacity
  } else if (trend < 0) {
    color = theme.palette.error.main;
    bg = theme.palette.error.main + '14';
  }
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 3,
    fontSize: 12,
    fontWeight: 600,
    color,
    backgroundColor: bg,
    borderRadius: 6,
    padding: '2px 6px',
    marginTop: 6,
    width: 'fit-content',
  };
});

export const SparklineContainer = styled(Box)({
  position: 'absolute',
  bottom: 0,
  right: 0,
  width: 80,
  height: 48,
  pointerEvents: 'none',
});

export const LimitsRow = styled(Box)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '4px 20px 6px',
  borderTop: '1px solid rgba(0,0,0,0.06)',
  backgroundColor: 'inherit',
});

export const LimitLabel = styled(Box)(({ color }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  fontSize: 11,
  fontWeight: 500,
  color: color || 'inherit',
  '& .MuiSvgIcon-root': {
    fontSize: 14,
  },
}));
